import { useEffect, useState } from "react";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useAndamentoAlteraaoExecutor = () => {
  const [docParams, setDocParams] = useState({ sqAlteracaoExecutor: null, sqAndamento: null });
  const { request, data: dataDocumento } = useApiClient();

  useEffect(() => {
    if (docParams?.sqAlteracaoExecutor && docParams?.sqAndamento) {
      const values = docParams;
      request(apiRoutes.fiscalizacao.alteracaoexecutor.andamentoAlteracaoExecutorHtml, values);
    }
  }, [request, docParams]);

  useEffect(() => {
    let win;
    if (dataDocumento?.result) {
      win = window.open("", "", "height=800, width=800");
      win.document.write(dataDocumento.result);
      win.document.close();
      win.setTimeout(win.print, 1000);
    }
  }, [dataDocumento]);

  return { setDocParams };
};

export default useAndamentoAlteraaoExecutor;
